<!--
 * @Author: CHY
 * @Date: 2023-08-25 11:23:25
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-08-26 08:42:52
 * @FilePath: \cheapFood\src\components\indexModule\footerPage.vue
-->
<template>
    <div class="footer_page">
        <div class="websiteList flex cursor">
            <!-- <div>省市纪检部门网站</div> trigger="hover" -->
            <div v-for="(item, index) in footerData" :key="index" class="category">
                <!-- <div> -->
                <el-popover popper-class="footerPopper" trigger="hover">
                    <div class="list" v-if="item[listKey].length>0">
                        <div v-for="(itm, idx) in item[listKey]" :key="idx">
                            <a v-if="itm.url" :href="itm.url?itm.url:'/'" target="_blank" class="single cursor overflow disabledCopy">
                                <span class="text">{{itm.name || '暂无链接名称'}}</span>
                            </a>
                        </div>
                    </div>
                    <div v-else class="list disabledCopy cursor" style="text-align:center;">
                        <div>{{'暂无子链接'}}</div>
                    </div>
                    <div class="overflow" slot="reference">{{item.title || '暂无链接类别'}}</div>
                </el-popover>
                <!-- </div> -->
            </div>
        </div>
        <div class="line"></div>
        <div class="infos">
            <!-- 主办单位：纪检监察部门 教育部门  -->
            <div class="address">主办单位：纪检监察部门 教育部门 技术支持：广州红新智能科技有限公司</div>
            <div><a href="https://beian.miit.gov.cn">网站备案号：粤ICP备2020138104号</a></div>
            <div class="qr_code">
                <img src="@/assets/image/index/public_qr_code.jpg" alt="关注廉餐公众号">
                <div>扫码关注廉餐公众号</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'footerPage',
        props: {
            footerData: {
                type: Array,
                default: () => []
            },
            listKey: {
                type: String,
                default: ''
            }
        },
        data() {
            return {}
        },
        components: {},
        created() {},
        computed: {},
        watch: {},
        methods: {
            // 点击更多
            onClickMore() {
                console.log('点击更多')
                this.$emit('onClickMore', true)
            }
        }
    }
</script>

<style lang='less' scoped>
    .footer_page {
        width: 100%;

        .websiteList {
            flex-wrap: wrap;
            align-items: center;
            width: 1250px;
            margin: 0 auto;
            padding: 40px 0 20px;

            .category {
                width: 250px;
                height: 25px;
                line-height: 25px;
                font-size: 16px;
                color: #a6c6ff;
                border-right: 1px solid #2869db;
                box-sizing: border-box;
                margin-bottom: 20px;
                padding: 0 10px;

                &:nth-child(5n) {
                    border-right: none;
                }

                &:hover {
                    opacity: 0.6;
                }
            }
        }

        .line {
            height: 1px;
            background: #2869db;
        }

        .infos {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 950px;
            height: 175px;
            font-size: 14px;
            color: #a6c6ff;
            margin: 0 auto;

            .address {
                margin-bottom: 15px;
            }

            .qr_code {
                position: absolute;
                right: 0;
                top: 50%;
                transform: translate(-50%, -50%);
                font-size: 14px;
                font-weight: 600;
                color: #ffffff;

                >img {
                    width: 100px;
                    height: 100px;
                    margin-bottom: 5px;
                }

                &:hover {
                    transform: translate(-50%, -50%);
                }
            }
        } 
       
    }
</style>
<style lang="less">
    .footerPopper {
        /deep/.list {
            max-width: 300px;

            a {
                color: #333333;

                &:visited {
                    color: #551a8b;
                }

                &:hover {
                    opacity: 0.6;
                }
            }

            .single {
                display: flex;
                align-items: center;
                line-height: 25px;

                &::before {
                    content: '';
                    display: block;
                    width: 5px;
                    height: 5px;
                    border: 1px solid #2869db;
                    border-radius: 50%;
                    margin-right: 5px;
                }

                .text {
                    width: 100%;
                    line-height: 20px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/indexModule/footerPage.vue